import { useNavigate } from 'react-router-dom';

export default function Features() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: '100vh', background: '#f9fafb', fontFamily: 'system-ui' }}>
      {/* Header */}
      <header style={{
        background: 'white',
        borderBottom: '1px solid #e5e7eb',
        padding: '20px',
      }}>
        <div style={{
          maxWidth: '1200px',
          margin: '0 auto',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }} onClick={() => navigate('/')}>
            <span style={{ fontSize: '24px' }}>🖊️</span>
            <h1 style={{ margin: 0, fontSize: '20px', color: '#1f2937' }}>VirtueSign</h1>
          </div>
          <button
            onClick={() => navigate('/login')}
            style={{
              background: '#667eea',
              color: 'white',
              padding: '10px 24px',
              border: 'none',
              borderRadius: '6px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
          >
            Sign In
          </button>
        </div>
      </header>

      {/* Hero */}
      <section style={{
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        padding: '60px 20px',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <h1 style={{ fontSize: '48px', marginBottom: '20px', fontWeight: '700' }}>
            Email Signature Management Features for Microsoft 365
          </h1>
          <p style={{ fontSize: '20px', opacity: 0.95, marginBottom: '30px' }}>
            Centralized control, Azure AD integration, and automated deployment for professional email signatures
          </p>
          <button
            onClick={() => navigate('/login')}
            style={{
              background: 'white',
              color: '#667eea',
              padding: '14px 32px',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '700',
              fontSize: '16px',
              cursor: 'pointer',
            }}
          >
            Get Started Free
          </button>
        </div>
      </section>

      {/* Main Content */}
      <main style={{ maxWidth: '1200px', margin: '0 auto', padding: '60px 20px' }}>
        
        {/* Core Features */}
        <section style={{ marginBottom: '80px' }}>
          <h2 style={{ fontSize: '36px', marginBottom: '40px', textAlign: 'center', color: '#1f2937' }}>
            Core Features
          </h2>
          
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(350px, 1fr))', gap: '30px' }}>
            <FeatureCard
              icon="🔗"
              title="Microsoft 365 Integration"
              description="Seamless integration with Exchange Online and Azure AD. One-click admin consent connects your organization in seconds. No complex setup or IT expertise required."
            />
            <FeatureCard
              icon="👥"
              title="Azure AD Synchronization"
              description="Automatic user and group sync from Azure Active Directory. Employee data updates in real-time, keeping signatures current without manual intervention."
            />
            <FeatureCard
              icon="🎨"
              title="Visual Template Designer"
              description="Drag-and-drop signature builder with live preview. No HTML or coding skills needed. Design professional signatures with logos, social icons, and custom fields."
            />
            <FeatureCard
              icon="📊"
              title="Group-Based Assignments"
              description="Assign signature templates by Azure AD groups. Set priority rules for users in multiple groups. Deploy signatures automatically based on department, role, or location."
            />
            <FeatureCard
              icon="🔄"
              title="Automatic Deployment"
              description="Outlook add-in automatically inserts signatures on new messages. Works across Outlook Desktop, Web, and Mobile. No user training required."
            />
            <FeatureCard
              icon="🏢"
              title="Enterprise Ready"
              description="Scalable solution for organizations of all sizes. Manage signatures across departments and locations with role-based access control."
            />
          </div>
        </section>

        {/* Template Designer Features */}
        <section style={{ marginBottom: '80px' }}>
          <h2 style={{ fontSize: '36px', marginBottom: '20px', color: '#1f2937' }}>
            Professional Template Designer
          </h2>
          <p style={{ fontSize: '18px', color: '#6b7280', marginBottom: '40px', maxWidth: '800px' }}>
            Create branded email signatures that align with your company's visual identity
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px' }}>
            <div>
              <h3 style={{ fontSize: '24px', marginBottom: '20px', color: '#1f2937' }}>Dynamic Fields</h3>
              <ul style={{ fontSize: '16px', lineHeight: '1.8', color: '#374151' }}>
                <li>📧 <strong>Email</strong> - Automatic mailto links</li>
                <li>👤 <strong>Full Name</strong> - From Azure AD profile</li>
                <li>💼 <strong>Job Title</strong> - Department and position</li>
                <li>📞 <strong>Phone Numbers</strong> - Office, mobile, direct line</li>
                <li>🏢 <strong>Company Information</strong> - Name, address, VAT number</li>
                <li>🌐 <strong>Website</strong> - Clickable company URL</li>
                <li>🖼️ <strong>Profile Photos</strong> - Individual employee photos</li>
                <li>📱 <strong>Social Media</strong> - LinkedIn, Twitter, Facebook icons</li>
              </ul>
            </div>

            <div>
              <h3 style={{ fontSize: '24px', marginBottom: '20px', color: '#1f2937' }}>Customization Options</h3>
              <ul style={{ fontSize: '16px', lineHeight: '1.8', color: '#374151' }}>
                <li>🎨 Custom fonts and colors</li>
                <li>🖼️ Logo management and positioning</li>
                <li>📐 Grid-based layout system</li>
                <li>✨ Text formatting (bold, italic, colors)</li>
                <li>📏 Custom field prefixes and labels</li>
                <li>🔗 Conditional field display</li>
                <li>📋 Multiple logo support</li>
              </ul>
            </div>
          </div>
        </section>

        {/* Administration Features */}
        <section style={{ marginBottom: '80px', background: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
          <h2 style={{ fontSize: '36px', marginBottom: '20px', color: '#1f2937' }}>
            Centralized Administration
          </h2>
          <p style={{ fontSize: '18px', color: '#6b7280', marginBottom: '30px' }}>
            Complete control over email signatures across your entire organization
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '30px' }}>
            <div>
              <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#1f2937', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>👨‍💼</span>User Management
              </h3>
              <p style={{ fontSize: '15px', color: '#6b7280', lineHeight: '1.6' }}>
                View and manage all users synced from Azure AD. Track signature assignments and deployment status. Filter by department, group, or custom attributes.
              </p>
            </div>

            <div>
              <h3 style={{ fontSize: '20px', marginBottom: '12px', color: '#1f2937', display: 'flex', alignItems: 'center', gap: '8px' }}>
                <span>👥</span>Group Policies
              </h3>
              <p style={{ fontSize: '15px', color: '#6b7280', lineHeight: '1.6' }}>
                Create assignment rules based on Azure AD groups. Set priority levels for overlapping group memberships. Automatic assignment when users join groups.
              </p>
            </div>
          </div>
        </section>

        {/* Deployment Features */}
        <section style={{ marginBottom: '80px' }}>
          <h2 style={{ fontSize: '36px', marginBottom: '20px', color: '#1f2937' }}>
            Outlook Add-in Deployment
          </h2>
          <p style={{ fontSize: '18px', color: '#6b7280', marginBottom: '30px', maxWidth: '800px' }}>
            Deploy the Outlook add-in organization-wide through Microsoft 365 Admin Center
          </p>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '25px' }}>
            <div style={{ textAlign: 'center', padding: '30px', background: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <div style={{ fontSize: '48px', marginBottom: '15px' }}>💻</div>
              <h3 style={{ fontSize: '18px', marginBottom: '10px', color: '#1f2937' }}>Outlook Desktop</h3>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>Windows and Mac support with event-based automatic insertion</p>
            </div>

            <div style={{ textAlign: 'center', padding: '30px', background: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <div style={{ fontSize: '48px', marginBottom: '15px' }}>🌐</div>
              <h3 style={{ fontSize: '18px', marginBottom: '10px', color: '#1f2937' }}>Outlook Web</h3>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>Full support in modern browsers (Chrome, Edge, Firefox)</p>
            </div>

            <div style={{ textAlign: 'center', padding: '30px', background: 'white', borderRadius: '8px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
              <div style={{ fontSize: '48px', marginBottom: '15px' }}>📱</div>
              <h3 style={{ fontSize: '18px', marginBottom: '10px', color: '#1f2937' }}>Outlook Mobile</h3>
              <p style={{ fontSize: '14px', color: '#6b7280' }}>iOS and Android automatic signature insertion</p>
            </div>
          </div>
        </section>

        {/* Security & Compliance */}
        <section style={{ marginBottom: '80px' }}>
          <h2 style={{ fontSize: '36px', marginBottom: '20px', color: '#1f2937' }}>
            Security & Compliance
          </h2>
          <p style={{ fontSize: '18px', color: '#6b7280', marginBottom: '30px', maxWidth: '800px' }}>
            Enterprise-grade security built on Microsoft 365 standards
          </p>

          <div style={{ background: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 1px 3px rgba(0,0,0,0.1)' }}>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '30px' }}>
              <div>
                <h3 style={{ fontSize: '20px', marginBottom: '15px', color: '#1f2937' }}>🔒 Data Security</h3>
                <ul style={{ fontSize: '15px', lineHeight: '1.8', color: '#374151' }}>
                  <li>End-to-end encryption for sensitive credentials</li>
                  <li>Microsoft OAuth 2.0 authentication</li>
                  <li>No password storage</li>
                  <li>Secure token management</li>
                </ul>
              </div>

              <div>
                <h3 style={{ fontSize: '20px', marginBottom: '15px', color: '#1f2937' }}>✅ Compliance</h3>
                <ul style={{ fontSize: '15px', lineHeight: '1.8', color: '#374151' }}>
                  <li>GDPR compliant data processing</li>
                  <li>Data residency options</li>
                  <li>Audit logging for all actions</li>
                  <li>Microsoft security standards</li>
                </ul>
              </div>
            </div>
          </div>
        </section>

        {/* Use Cases */}
        <section style={{ marginBottom: '80px' }}>
          <h2 style={{ fontSize: '36px', marginBottom: '40px', textAlign: 'center', color: '#1f2937' }}>
            Perfect For
          </h2>

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '30px' }}>
            <UseCase
              icon="🏢"
              title="Enterprise Organizations"
              description="Manage signatures for hundreds or thousands of employees across multiple departments and locations with centralized control."
            />
            <UseCase
              icon="💼"
              title="IT Departments"
              description="Save hours of manual work. Automate signature deployment and eliminate support tickets for signature updates."
            />
            <UseCase
              icon="📢"
              title="Marketing Teams"
              description="Ensure brand consistency across all email communications. Update company-wide campaigns and messaging instantly."
            />
          </div>
        </section>

        {/* CTA */}
        <section style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          color: 'white',
          padding: '60px 40px',
          borderRadius: '16px',
          textAlign: 'center',
        }}>
          <h2 style={{ fontSize: '36px', marginBottom: '20px' }}>
            Ready to Get Started?
          </h2>
          <p style={{ fontSize: '18px', opacity: 0.95, marginBottom: '30px', maxWidth: '600px', margin: '0 auto 30px' }}>
            Deploy professional email signatures across your Microsoft 365 organization in minutes
          </p>
          <button
            onClick={() => navigate('/login')}
            style={{
              background: 'white',
              color: '#667eea',
              padding: '16px 40px',
              border: 'none',
              borderRadius: '8px',
              fontWeight: '700',
              fontSize: '18px',
              cursor: 'pointer',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
            }}
          >
            Start Free Trial
          </button>
          <p style={{ marginTop: '20px', fontSize: '14px', opacity: 0.9 }}>
            No credit card required • 5 minute setup
          </p>
        </section>
      </main>

      {/* Footer */}
      <footer style={{
        background: 'white',
        borderTop: '1px solid #e5e7eb',
        padding: '40px 20px',
        textAlign: 'center',
      }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto' }}>
          <p style={{ color: '#6b7280', marginBottom: '20px' }}>
            © {new Date().getFullYear()} VirtueSign by Virtue ApS - Email Signature Management for Microsoft 365
          </p>
          <div style={{ display: 'flex', gap: '20px', justifyContent: 'center', flexWrap: 'wrap' }}>
            <a href="/" style={{ color: '#667eea', textDecoration: 'none' }}>Home</a>
            <a href="/support" style={{ color: '#667eea', textDecoration: 'none' }}>Support</a>
            <a href="/privacy" style={{ color: '#667eea', textDecoration: 'none' }}>Privacy</a>
            <a href="/terms" style={{ color: '#667eea', textDecoration: 'none' }}>Terms</a>
          </div>
        </div>
      </footer>
    </div>
  );
}

function FeatureCard({ icon, title, description }: { icon: string; title: string; description: string }) {
  return (
    <div style={{
      background: 'white',
      padding: '30px',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      border: '1px solid #e5e7eb',
    }}>
      <div style={{ fontSize: '40px', marginBottom: '15px' }}>{icon}</div>
      <h3 style={{ fontSize: '20px', marginBottom: '12px', fontWeight: '600', color: '#1f2937' }}>{title}</h3>
      <p style={{ fontSize: '15px', color: '#6b7280', lineHeight: '1.6' }}>{description}</p>
    </div>
  );
}

function UseCase({ icon, title, description }: { icon: string; title: string; description: string }) {
  return (
    <div style={{
      background: 'white',
      padding: '30px',
      borderRadius: '12px',
      boxShadow: '0 1px 3px rgba(0,0,0,0.1)',
      textAlign: 'center',
    }}>
      <div style={{ fontSize: '48px', marginBottom: '15px' }}>{icon}</div>
      <h3 style={{ fontSize: '20px', marginBottom: '12px', fontWeight: '600', color: '#1f2937' }}>{title}</h3>
      <p style={{ fontSize: '15px', color: '#6b7280', lineHeight: '1.6' }}>{description}</p>
    </div>
  );
}
